<template>
  <el-dialog width="70%"
             v-dialog-drag
             title="获取小程序用户隐私"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="getPrivacySettingVisible">
    <div class="from_box" v-loading="loading">
      <el-radio-group v-model="currencyForm.privacy_ver" @change="handleChangepPrivacy">
        <el-radio label="1">现网版本</el-radio>
        <el-radio label="2">开发版本</el-radio>
      </el-radio-group>

      <div class="details_wrap">
        {{details}}
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {getPrivacySetting} from "@/api";

export default {
  name: "get_privacySetting",
  props: {
    getPrivacySettingVisible: {
      type: Boolean,
      default: false,
    },
    weChatAppId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      currencyForm:{
        privacy_ver:'1', //1表示现网版本；2表示开发版
      },
      currencyFormRules:{

      },
      details:{}
    }
  },
  created() {

  this.getPrivacySettingDetail()
  },
  mounted() {
  },
  methods: {

    handleClickCancel() {
      this.$emit('update:getPrivacySettingVisible', false)
    },

    handleChangepPrivacy(value){
      console.log(value);
      if(value){
        this.getPrivacySettingDetail()
      }
    },

    getPrivacySettingDetail(){
      this.loading = true
      getPrivacySetting({privacy_ver: this.currencyForm.privacy_ver},{
        headers:{
          appid: this.weChatAppId,
        }
      }).then(res => {
        if (res.data.errcode === 0) {
          this.details = res.data
        }
        this.loading = false
      })

    },
  }
}
</script>
<style lang="scss" scoped>
.from_box{
  padding: 30px 0 15px;
}
.details_wrap{
  max-height: 420px;
  overflow: auto;
  word-break: break-all;
  margin-top: 20px;
}
</style>
